<template>
  <div>
    <div>
      <div class="query_head">
        <span class="query_pond">终端信息</span>
      </div>
      <div class="table_flex">
        <div>
          <el-table
            :data="tableData"
            style="width: 600px">
            <el-table-column prop="num" label="序号" width="75" sortable  column-key="num"></el-table-column>
            <el-table-column prop="termname" label="终端名称" width="128" sortable column-key="termid"></el-table-column>
            <el-table-column prop="status" label="状态" width="77" sortable column-key="status"></el-table-column>
            <el-table-column prop="intime" label="上线时间" width="160" sortable column-key="intime"></el-table-column>
            <el-table-column prop="outtime" label="下线时间" width="160" sortable column-key="outtime"></el-table-column>
          </el-table>
        </div>
        <div>
          <div class="table_sen">
            <el-form ref="form" :model="form" label-width="95px">
              <el-form-item label="终端选择:" class="change_term">
                <el-select v-model="form.termid"  placeholder="请选择终端" class="date_pick">
                  <el-option v-for="(term,index) in  tableData" :key="index" :label="term.termname" :value="term.termid"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <el-table
            :data="phyList"
            style="width: 400px; margin-left: 20px;">
            <el-table-column prop="phyname" label="传感器名称" width="140" sortable column-key="phyname"></el-table-column>
            <el-table-column prop="phystatus" label="状态" width="90" sortable column-key="phystatus"></el-table-column>
            <el-table-column prop="lstime" label="最后上报时间" width="170" sortable column-key="lstime"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div style="margin-top: 20px;">
      <div class="query_head">
        <span class="query_pond">终端电量历史</span>
      </div>
      <div class="electric">
        <div class="table_ele">
          <div>
            <el-form ref="form" :model="form" label-width="95px">
              <el-form-item label="终端选择:" class="change_term" style="margin-bottom: 0;">
                <el-select v-model="form.termeleid"  placeholder="请选择终端" class="date_pick">
                  <el-option v-for="(term,index) in  tableData" :key="index" :label="term.termname" :value="term.termid"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="el-form-item__label change_term change_time">时间选择：</div>
            <el-date-picker
              class="date_pick"
              v-model="his_time"
              type="datetimerange"
              :picker-options="pickerOptions"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['12:00:00', '08:00:00']">
            </el-date-picker>
            <el-button class="margin_left" type="primary" @click="findData()">确定</el-button>
          </div>
        </div>
        <div class="hisQurey" ref="hisQurey" :style="{width: '1000px', height:'470px'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      tableData: [],
      phyList: [],
      form: {
        termid: '',
        termeleid: ''
      },
      listTerm: [],
      his_time: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      his_data_x: [],
      his_data_y: []
    }
  },
  methods: {
    // 查询用户下所有终端的状态
    getAllSta () {
      this.axios.get(this.$store.state.ip + 'opt/usrTermSta',
        {
          params: {'usrname': this.username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.tableData = res.data.data
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].num = i + 1
          if (this.tableData[i].status === 'false') {
            this.tableData[i].status = '关'
          } else {
            this.tableData[i].status = '开'
          }
          if (this.tableData[i].intime === null) {
            this.tableData[i].intime = 'null'
          }
          if (this.tableData[i].outtime === null) {
            this.tableData[i].outtime = 'null'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取终端下所有传感器的状态
    getAllList () {
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].termid === this.form.termid) {
          this.phyList = this.tableData[i].phyList
        }
      }
      for (let j = 0; j < this.phyList.length; j++) {
        if (this.phyList[j].phystatus === 'false') {
          this.phyList[j].phystatus = '关'
        } else {
          this.phyList[j].phystatus = '开'
        }
      }
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    findData () {
      this.axios.get(this.$store.state.ip + 'opt/voltHisQuery',
        {
          params: {'term_id': this.form.termeleid, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        console.log(res.data.data)
        this.his_data_x = res.data.data.times
        this.his_data_y = res.data.data.values
        for (let i = 0; i < this.his_data_x.length; i++) {
          let test = new Date(this.his_data_x[i] * 1000)
          let year = test.getFullYear() // 取得4位数的年份
          let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
          let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
          let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
          let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
          let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
          this.his_data_x[i] = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        }
        let mycharts = this.$echarts.init(this.$refs.hisQurey)
        mycharts.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          color: ['#91c7ae'],
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            containLabel: true
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 0
              // end: 25 / this.his_data_x.length * 100
            },
            {
              type: 'inside',
              realtime: true,
              start: 0,
              end: 100
            }
          ],
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.his_data_x
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '历史数据',
              type: 'line',
              stack: '总量',
              itemStyle: {
                normal: { // 背景色渐变
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0, color: '#aed4c2'
                  }, {
                    offset: 0.5, color: 'rgba(174, 212, 194, 0.5)'
                  }, {
                    offset: 0.85, color: '#fff'
                  }]),
                  lineStyle: { // 折线样式
                    width: 2.5,
                    type: 'solid',
                    color: '#91c7ae' // 拆线颜色
                  }
                },
                emphasis: {
                  color: '#91c7ae',
                  lineStyle: {
                    type: 'dotted',
                    color: '#91c7ae'
                  }
                }
              },
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
              symbolSize: 5,
              areaStyle: {
                normal: {}
              },
              data: this.his_data_y
            }
          ]
        })
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.getAllSta()
  },
  watch: {
    'form.termid': function () {
      this.getAllList()
    }
  }
}
</script>

<style scoped>
  .table_flex{
    display: flex;
    align-items: left;
    justify-content: left;
  }
  .change_term {
    font-weight: bold;
    margin-right: 10px;
  }
  .table_sen {
    display: flex;
    align-items: center;
    justify-content: left;
    margin-top: -7px;
    margin-bottom: -8px;
  }
  .electric {
    width: 100%;
    background-color: white;
  }
  .date_pick {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .table_ele {
    display: flex;
    align-items: center;
    justify-content: left;
    padding-top: 20px;
  }
  .change_time {
    padding: 0;
    margin-left: 20px;
  }
  .margin_left {
    margin-left: 20px;
  }
  .hisQurey{
    margin: 0 auto;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/termInfo.vue